import React, {Suspense, useEffect, useState} from 'react'
import {Route, Routes as ReactRouterRoutes, Navigate} from 'react-router-dom'
import {FallbackView} from '../../cms/partials'
import {RouteList, RouteModel} from './RoutesList'
import {useSelector} from 'react-redux'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {isEmpty} from 'lodash'
import {ProfileHeader} from '../modules/profileComponent/components/ProfileHeader'
import FileManager from '../modules/common/components/fileManager/components'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Error404} from '../modules/errors/components/Error404'

export function PrivateRoutes() {
  const module: any = useSelector((state: any) => state.auth.module)
  const [authorizedRoute, setAuthorizedRoute] = useState<Array<string>>([])
  useEffect(() => {
    if (isEmpty(authorizedRoute)) {
      let newAuthorizedRoute = [...authorizedRoute]
      module?.moduleData?.map((modules: any) =>
        modules.children
          ? modules.children?.map((route: any) => {
              newAuthorizedRoute?.push(route?.alias)
            })
          : newAuthorizedRoute?.push(modules?.alias)
      )
      setAuthorizedRoute(newAuthorizedRoute)
    }
  }, [module])

  const renderRoute = RouteList?.filter((route, i: number) => {
    return authorizedRoute?.some((authPath) => route?.path?.includes(authPath))
  })

  /* {RouteList?.map(
          (route: any, i: number) =>
            authorizedRoute?.includes(route?.path) && (
              <Route path={route?.path} component={route?.component} key={i} exact={route?.exact} />
            )
        )} */
 console.log('authorizedRoute', authorizedRoute,RouteList)
  return (
    <Suspense fallback={<FallbackView />}>
      <ReactRouterRoutes>
        <Route path='/dashboard' element={<DashboardWrapper />} />
        <Route path='/media-manager' element={<FileManager />} />
        <Route path='/profile' element={<ProfileHeader />} />
        {RouteList?.filter((route) => {
          return authorizedRoute?.some((authPath) => route?.path?.includes(authPath))
        }).map((item, i: number) => {
          const Component = item.component as React.ComponentType<any>
          return (
            <Route path={item?.path} element={React.createElement(Component as any, {})} key={i} />
          )
        })}

        <Route path='/auth/*' element={<Navigate to='/dashboard' replace />} />
        <Route path='/' element={<Navigate to='/dashboard' replace />} />
        <Route path='*' element={<Error404 />} />
      </ReactRouterRoutes>
    </Suspense>
  )
}
